<template>
  <q-img
    :src="src || '/images/placeholder.png'"
    :ratio="ratio"
    spinner-color="primary"
    :class="['rounded-borders', customClass]"
    @error="handleImageError"
    v-bind="$attrs"
  >
    <template v-slot:loading>
      <q-inner-loading showing color="primary">
        <q-spinner-dots :size="loadingSize" />
      </q-inner-loading>
    </template>
    <template v-slot:error>
      <div class="absolute-full flex flex-center bg-grey-3">
        <q-icon :name="errorIcon" :size="errorIconSize" color="grey-7" />
      </div>
    </template>
    <slot></slot>
  </q-img>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  src: String,
  ratio: {
    type: Number,
    default: 1
  },
  customClass: {
    type: String,
    default: ''
  },
  errorIcon: {
    type: String,
    default: 'local_offer'
  },
  errorIconSize: {
    type: String,
    default: '50px'
  },
  loadingSize: {
    type: String,
    default: '40px'
  }
});

function handleImageError(evt) {
  evt.target.src = '/images/placeholder.png';
  evt.target.onerror = null;
  evt.target.classList.add('fallback-image');
}
</script>
